import React, { memo } from 'react';
import Styles from './auth-header-styles.scss';
import LogoAuth2 from '../logo/logoAuth2';
import AuthHeaderPartner from './auth-header-partner';
const LoginHeader = () => {
    return (React.createElement("header", { className: Styles.headerWrap },
        React.createElement(LogoAuth2, null),
        React.createElement(AuthHeaderPartner, null)));
};
export default memo(LoginHeader);
